import React, { Component } from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from '../components/confirmDialog';
import * as webViewerServersActions from '../store/webViewerServersSlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import { showModalMessage } from '../store/modalsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Remove: 0,
  Restore: 1
};

class RemoveRestoreWebViewerServersConfirmDialog extends Component {
  static get Mode() {
    return Mode;
  }

  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onConfirm() {
    let processor = null;

    if (this.props.mode === Mode.Remove)
      processor = this.props.removeWebViewerServers;
    else if (this.props.mode === Mode.Restore)
    processor = this.props.restoreWebViewerServers;

    if (processor !== null) {
      processor({ webViewerServerIds: this.props.serverIds })
        .then(unwrapResult)
        .catch(() => {
          this.props.showModalMessage("Error", this.props.error.toString());
        });
    }
    this.props.onClose();
  }

  render() {
    let qoperation = null;
    let toperation = null;
    if (this.props.mode === Mode.Remove) {
      qoperation = "remove";
      toperation = "removing";
    } else if (this.props.mode === Mode.Restore) {
      qoperation = "restore";
      toperation = "restoring";
    }
    else
      return null;

    let c = this.props.serverIds.length;
    let question = <React.Fragment>
      {`Are you sure want to ${qoperation} `}
      {c > 1 ? <strong>{c} </strong> : ""}
      {`selected web viewer server${c > 1 ? "s" : ""}?`}
      </React.Fragment>;
    return (
      <ConfirmDialog
        show={this.props.show}
        onClose={this.props.onClose}
        title={`Web viewer servers ${toperation}`}
        question={question}
        onConfirm={this.onConfirm}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  error: webViewerServersSelectors.state(state).removingRestoringError,
});

const actionCreators = {
  removeWebViewerServers: webViewerServersActions.remove,
  restoreWebViewerServers: webViewerServersActions.restore,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
}

export default connect(mapStateToProps, actionCreators)(RemoveRestoreWebViewerServersConfirmDialog);


// WEBPACK FOOTER //
// ./src/containers/removeRestoreWebViewerServersConfirmDialog.js